import { useQueryClient } from "@tanstack/react-query";
import {
  useProfileControllerDismissAudiolabBanner,
  useProfileControllerCollapseAudiolabBanner,
} from "@/lib/lutely-api/gen/profile/profile";
import { getAuthControllerGetCurrentUserQueryKey } from "@/lib/lutely-api/gen/auth/auth";

export function useOnboardingBannerMutations(onCollapseSuccess?: () => void) {
  const queryClient = useQueryClient();

  const dismissMutation = useProfileControllerDismissAudiolabBanner({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getAuthControllerGetCurrentUserQueryKey(),
        });
      },
    },
  });

  const collapseMutation = useProfileControllerCollapseAudiolabBanner({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getAuthControllerGetCurrentUserQueryKey(),
        });
        onCollapseSuccess?.();
      },
    },
  });

  return {
    dismissMutation,
    collapseMutation,
  };
}
